import { useNavigate } from "react-router-dom-v5-compat";
import { FlightLocationSelection } from "@b2bportal/core-flights/overridable";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Funnel, IdEnum, type ITripTerminus } from "@b2bportal/core-types";
import { Page } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { RegionType } from "@hopper-b2b/types";
import { useDeviceTypes } from "@hopper-b2b/utilities";
import {
  PremierDestinationQuickPicks,
  type PromotedDestinationCity,
  SimplePageHeader,
  usePremierDestinationPromotion,
} from "@hsbc/portal";
import { FLIGHTS_PATH } from "@hsbc/utilities";
import {
  useSearchLocation,
  type UseSearchLocationParams,
} from "./hooks/useSearch";
import styles from "./styles.module.scss";

/**
 * This component is only used for flights search.
 * To support other funnels, please update navigate destination.
 */
export const Search = (props: UseSearchLocationParams) => {
  const { t } = useI18nContext();
  const { matchesMobile } = useDeviceTypes();
  const [, cn] = useModuleBEM(styles, "Search");

  const {
    context: { selectedLocation, titleKey },
    handlers: { onChange },
  } = useSearchLocation(props);
  const navigate = useNavigate();

  const {
    activePremierDestinations: { flights: activePremierDestinations },
    enabledPromotions: { flights: enablePremierDestination },
  } = usePremierDestinationPromotion();

  const onPremierDestinationSelect = ({
    code,
    label,
  }: PromotedDestinationCity) => {
    const selectedCity: ITripTerminus = {
      id: {
        code: {
          regionType: RegionType.City,
          code,
        },
        Id: IdEnum.Flight,
      },
      label,
      trackingProperties: {},
    };

    onChange(selectedCity);
  };

  return (
    <Page
      header={
        <SimplePageHeader
          title={t(titleKey)}
          onBack={() => navigate(FLIGHTS_PATH)}
        />
      }
      footer={<></>}
    >
      <div>
        <FlightLocationSelection
          autoFocus
          className={cn("location-selection")}
          locationChangeHandler={onChange}
          popperClassName={cn("location-selection-popper", {
            mobile: matchesMobile,
          })}
          label={t("home.flightLocationSearchLabel")}
          selectedLocation={selectedLocation}
        />

        {enablePremierDestination && (
          <div className={cn("premier-destination-quick-picks")}>
            <PremierDestinationQuickPicks
              funnel={Funnel.Air}
              onSelect={onPremierDestinationSelect}
              activePremierDestinations={activePremierDestinations}
            />
          </div>
        )}
      </div>
    </Page>
  );
};
